// import { TemplateHandler } from 'easy-template-x';
import { SERVICE_URL } from '../evironment';
import { getAccessToken } from './session';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
export class FileService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async findFilesByContext(contextId) {
        if (contextId) {
            const response = await this.apiService.get('files/context/' + contextId);
            if (!response.ok) {
                throw new Error(`Error al obtener los Files.`);
            }
            const content = await response.json();
            return content;
        }
        else {
            throw new Error(`Error al obtener contextId.`);
        }
    }
    async findFileByID(fileId) {
        if (fileId) {
            const response = await this.apiService.get('files/content/' + fileId);
            if (!response.ok) {
                throw new Error(`Error al obtener los Files.`);
            }
            const content = await response.json();
            return content;
        }
        else {
            throw new Error(`Error al obtener fileId.`);
        }
    }
    async downloadFile(fileType, fileName, data, fileId) {
        let filesArray = [];
        filesArray = await this.findFilesByContext(fileType);
        let file = filesArray.filter(file => file.id === fileId);
        try {
            if (!confirm('¿Esta seguro de querer descargar el archivo ' + file[0].name + '?')) {
                return;
            }
            let urlTodown = new URL(`/api/download/${file[0].id}`, SERVICE_URL);
            if (SERVICE_URL.includes('localhost')) {
                urlTodown = new URL(`/download/${file[0].id}`, SERVICE_URL);
            }
            urlTodown.searchParams.set('access_token', getAccessToken());
            const urlDown = urlTodown.toString();
            fetch(urlDown)
                .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
            });
            const response = await fetch(urlDown);
            // const templateFile = await response.blob();
            const templateFile = await response.arrayBuffer();
            if (data && templateFile) {
                try {
                    // const handler = new TemplateHandler({maxXmlDepth: 50})
                    // console.log(templateFile)
                    // console.log(data)
                    // const doc = await handler.process(templateFile, data);
                    const zip = new PizZip(templateFile);
                    const doc = new Docxtemplater(zip, {
                        linebreaks: true
                    });
                    doc.render(data);
                    const buf = doc.getZip().generate({
                        type: 'blob',
                        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                        compression: "DEFLATE",
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(/* doc */ buf);
                    ;
                    link.download = fileName + '.docx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                catch (error) {
                    console.log(error);
                }
            }
            else {
                throw Error('No hay datos que vincular');
            }
        }
        catch (error) {
            console.log(error);
        }
    }
}
